import { FC, MutableRefObject, PropsWithChildren } from "react";
import { NavLinkProps } from "react-router-dom";

import { SxProps } from "@mui/material";

import { ERoutes } from "@utils/constants";

import * as Styled from "./styles";

type TNavLink = {
  to: ERoutes;
  isFooter?: boolean;
  isDisabled?: boolean;
  end?: boolean;
  noLineAnimation?: boolean;
  navElems?: MutableRefObject<HTMLElement[]>;
  sx?: SxProps;
} & PropsWithChildren &
  NavLinkProps &
  Partial<Pick<HTMLAnchorElement, "target" | "id" | "onclick">>;

export const NavLink: FC<TNavLink> = ({
  isFooter = false,
  to,
  children,
  isDisabled = false,
  end = false,
  noLineAnimation = false,
  navElems,
  ...restProps
}) => {
  return (
    <Styled.NavLink
      to={to}
      $isFooter={isFooter}
      $isDisabled={isDisabled}
      $noLineAnimation={noLineAnimation}
      end={end}
      ref={(el) => {
        if (!navElems || !el) {
          return;
        }
        navElems.current[navElems.current.length] = el;
      }}
      {...restProps}
    >
      {children}
    </Styled.NavLink>
  );
};
